import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoint, colors, spacing, typography } from '../../../themes';

export const ChipButtonStyled = styled.button<{ active: boolean; hasSelected: boolean }>`
  display: inline-flex;
  padding: 4px 4px 4px 8px;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid ${colors.monochrome.grey20};
  ${typography.body.large};
  color: ${colors.primary.grey};

  ${({ active, hasSelected }) => {
    if (hasSelected) {
      return css`
        border: 0;
        color: ${colors.base.black};
        background: ${colors.primary.blueTint3} !important;
      `;
    }

    if (active) {
      return css`
        background: ${colors.background.grey};
      `;
    }

    return css`
      background: ${colors.base.white};
    `;
  }}

  &:hover {
    background: ${colors.background.grey};
  }

  @media (max-width: ${breakpoint.medium}px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const FloatingContainer = styled.div`
  display: flex;
  width: 250px;
  min-width: 150px;
  max-width: 300px;
  max-height: 300px;
  flex-direction: column;
  align-items: flex-start;
  z-index: 100;
  border-radius: 4px;
  border: 1px solid ${colors.monochrome.grey20};
  box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.08);
  background-color: white;
`;

export const ItemsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  padding: 0;
  box-sizing: border-box;
  overflow-y: auto;
  scrollbar-width: 8px;
  scrollbar-color: ${colors.monochrome.grey40} ${colors.base.white};

  &::-webkit-scrollbar {
    width: 8px;
  }
`;

export const SearchWrapper = styled.div`
  width: 100%;
  padding: ${spacing.xmsmall};
  box-sizing: border-box;
  border-bottom: 1px solid ${colors.monochrome.grey20};
`;

export const ClearButtonStyled = styled.div`
  all: unset;
  cursor: pointer;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpanStyled = styled.span`
  white-space: nowrap;
`;

export const ChipItem = styled.div<{ compact?: boolean }>`
  ${typography.body.large};
  color: ${colors.base.black};
  display: block;
  width: 100%;
  padding: ${({ compact }) => (compact ? '0' : `${spacing.xxsmall} ${spacing.xmsmall}`)};
  cursor: pointer;
`;
